import * as React from 'react';
import { Route, Routes, CompatRouter, } from "react-router-dom-v5-compat";
import { BrowserRouter, } from 'react-router-dom'

import SkillsReport from '../components/progress_reports/skills_report/index'

const SkillsReportRouter = (props) => (
  <BrowserRouter>
    <CompatRouter>
      <Routes>
        <Route element={<SkillsReport {...props} />} path="/teachers/progress_reports/skills_report/*" />
      </Routes>
    </CompatRouter>
  </BrowserRouter>
)

export default SkillsReportRouter
